import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Flag } from "@phosphor-icons/react";

export default function Report() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    target_user_id: params.get("target") || "",
    reason: "Inappropriate behavior",
    description: "",
  });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/reports", form);
      toast.success("Report submitted. Our team will review.");
      navigate("/");
    } catch (e) {
      toast.error("Could not submit report");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-16 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">Trust & Safety</div>
        <h1 className="font-display text-4xl mb-3 flex items-center gap-2"><Flag size={32} /> Report</h1>
        <p className="text-sm text-slate-600 mb-8">Help us keep CanHireSolution.com safe. All reports are confidential.</p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Target user ID</label>
            <input required value={form.target_user_id} onChange={(e) => setForm({ ...form, target_user_id: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5 font-mono text-sm" data-testid="report-target" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Reason</label>
            <select value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="report-reason">
              <option>Inappropriate behavior</option>
              <option>Spam</option>
              <option>Fraud / Scam</option>
              <option>Off-platform contact</option>
              <option>Discrimination / Harassment</option>
              <option>Other</option>
            </select>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Description</label>
            <textarea required rows={5} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="report-description" />
          </div>
          <button type="submit" disabled={busy} className="bg-accent-red text-white px-6 py-3 font-semibold disabled:opacity-50" data-testid="submit-report-btn">
            {busy ? "Submitting…" : "Submit report"}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
